var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRaceLogo = function SvgRaceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 28,
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.565 7.44h20.367l-4.649 4.72a4.141 4.141 0 0 1-2.95 1.236H38.018c-2.906 0-3.62.145-5.003 1.55L20.04 27.954h-8.823s14.91-14.956 17.397-17.48c2.66-2.7 3.745-3.034 9.952-3.034Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.337 23.134c5.22-5.19 12.734-12.661 14.005-13.879 2.58-2.472 3.84-2.867 9.45-2.867h22.176L66.259 0H37.202c-7.983 0-10.153.96-14.505 5.166C18.472 9.39 0 27.954 0 27.954h9.485c.663-.655 2.53-2.512 4.852-4.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.435 20.515H29.068l4.953-5.03a3.106 3.106 0 0 1 2.213-.926h13.748c2.906 0 3.62-.146 5.003-1.55L67.961 0h8.823s-14.91 14.956-17.397 17.481c-2.659 2.7-3.745 3.034-9.952 3.034Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.644 4.84C68.425 10.028 60.928 17.482 59.66 18.7c-2.58 2.472-3.84 2.866-9.45 2.866H28.033l-6.292 6.389H50.8c7.983 0 10.152-.96 14.504-5.166C69.53 18.566 88 0 88 0h-9.485c-.665.657-2.54 2.522-4.87 4.84Z"
  })));
};

export default SvgRaceLogo;